<template>
  <div class="locale-font">
    <div class="breadcrumb-container">
        <v-breadcrumbs :items="breadcrumbsItem"></v-breadcrumbs>
    </div>
    <div class="header-container">
        <h1 class="head-line-page">
            {{ breadcrumbsItem[1].text }}
        </h1>
        <div class="button-container">
            <v-btn
                class="mr-4"
                color="primary"
                outlined
                @click="backToVisitorList()">
                {{ this.$vuetify.lang.t('$vuetify.visitorForm.cancel') }}
            </v-btn>

            <v-btn
                color="primary"
                @click="onSubmit()">
                {{ this.$vuetify.lang.t('$vuetify.visitorForm.save') }}
            </v-btn>
        </div>
    </div>

    <div class="visitor-form-content-container">
        <div class="profile-card">
            <visitor-profile
                v-if="loading"
                ref="visitorProfile"
                v-model="visitorForm"
                :visitor="visitorForm"
                :mode="operationMode">
            </visitor-profile>
        </div>

        <div class="access-info-card">
            <visitor-access-info
                v-if="loading"
                ref="visitorAccessInfo"
                v-model="visitorPlan"
                :plans="visitorPlan"
                :mode="operationMode">
            </visitor-access-info>
        </div>
    </div>
  </div>
</template>

<script>
import VisitorProfile from '@/components/Visitor/VisitorProfile'
import VisitorAccessInfo from '@/components/Visitor/VisitorAccessInfo'

export default {
    name: 'VisitorForm',

    components: {
        VisitorProfile,
        VisitorAccessInfo
    },

    data () {
        return {
            loading: true,
            visitorId: null,
            operationMode: null,
            visitorForm: {},
            visitorPlan: {},
            tmpImage: null,
            dateList: [],
            nationalTelCode: '+66'
        }
    },

    computed: {
        breadcrumbsItem () {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.visitor.visitorLists'),
                    disabled: false,
                    exact: true,
                    to: {
                        name: 'VisitorLists'
                    }
                },
                {
                    text: this.operationMode === 'create' ? this.$vuetify.lang.t('$vuetify.visitorForm.visitorCreate') : this.$vuetify.lang.t('$vuetify.visitorForm.visitorEdit'),
                    disabled: true
                }
            ]
        }
    },

    methods: {
        backToVisitorList () {
            this.$router.push({ name: 'Visitor' }, () => {})
        },

        responseMsgNotify (title, msg, type) {
            this.$notify({
                title: title,
                text: msg,
                type: type
            })
        },

        async getVisitorInfo () {
            const res = await this.axios.get(`/visitor/${this.visitorId}`)
            if (res && res.data && res.data.status === 'ok') {
                const visitorInfo = res.data.data
                this.visitorForm = visitorInfo.info
                this.tmpImgProfile = visitorInfo.info.profileImage
                this.tmpImgCard = visitorInfo.info.cardImage
                this.visitorPlan = visitorInfo.plans
                this.visitorForm.phone = visitorInfo.info.phone.replace(this.nationalTelCode, '')
            } else {
                this.responseMsgNotify('Error', res.data.msg, 'notify-error')
            }
        },

        async onSubmit () {
            if (!this.$refs.visitorAccessInfo.validateFrom()) {
                return
            }

            if (!this.$refs.visitorProfile.validateFrom()) {
                return
            }

            this.visitorForm.phone = `${this.nationalTelCode} ${this.visitorForm.phone}`

            const body = {
                plan: this.visitorPlan,
                ...this.visitorForm
            }

            if (this.operationMode === 'edit') {
                await this.editVisitor(body)
            } else {
                await this.submitVisitor('Created Success', body)
            }
        },

        async editVisitor (body) {
            if (this.tmpImgProfile === body.profileImage) {
                body.profileImage = null
            }

            if (this.tmpImgCard === body.cardImage) {
                body.cardImage = null
            }

            await this.submitVisitor('Update Success', body)
        },

        async submitVisitor (titleMsg, body) {
            let res = null
            if (this.visitorId) {
                this.$store.dispatch('setLoading', true)
                res = await this.axios.put(`/visitor/edit/${this.visitorId}`, body)
            } else {
                this.$store.dispatch('setLoading', true)
                res = await this.axios.post('/visitor/create', body)
            }

            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.responseMsgNotify(titleMsg, res.data.msg, 'notify-success')
                this.backToVisitorList()
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.$refs.visitorProfile.setErrorsInput(res.data.errors)
                this.$store.dispatch('setLoading', false)
            } else {
                this.$store.dispatch('setLoading', false)
                this.responseMsgNotify('Error', res.data.msg, 'notify-error')
            }
        }
    },

    async mounted () {
        this.loading = false
        this.visitorId = this.$route.params.id
        if (this.visitorId) {
            await this.getVisitorInfo()
            this.operationMode = 'edit'
        } else {
            this.operationMode = 'create'
        }
        this.loading = true
    }

}
</script>

<style lang="scss" scoped>
.header-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
}

.visitor-form-content-container {
    display: flex;
    justify-content: space-between;
}

.profile-card {
    width: 68%;
}

.access-info-card {
    width: 31%;
}

::v-deep .breadcrumb-container .v-breadcrumbs {
    padding-bottom: 18px;
}
</style>
